import { defineStore } from 'pinia';
import api from "../../api";

export const useConfigurationStore = defineStore('configuration', {
  state: () => ({
    globalConfigurationList: [],
    total: 0,
  }),

  actions: {
    queryConfiguration(params, loading) {
        return api.configuration.queryConfiguration(params, loading)
          .then(json => {
             if (json.resp.respCode === 0 && json.switchPortStatus.rows.length) {
              this.setGlobalConfigurationList(json.switchPortStatus)

              }
            return json;
          })
          .catch(error => { throw error; });
      },
      setGlobalConfigurationList(data){
        this.globalConfigurationList = data.rows;
        this.total = data.total;
      },
      settingConfiguration(params, config) {
        return api.configuration.settingConfiguration(params, config)
          .then(data => data)
          .catch(error => { throw error; });
      },
  }
});
